export default {
  activity: {
    type: ['', '個人', '中國移動香港', '中國移動國際', '其他企業', '青少年團體'],
    bg: 'static/newYear/WebTC-06_340x200.jpg',
    department: ['業務交付中心', '公司事務部\n', '企業客戶銷售部\n', '客户體驗管理部\n', '客戶服務部\n', '財務部\n', '人力資源部\n',
      '資訊科技部\n', '內審部\n', '法律及監管部\n', '市場部\n', 'MyLink部\n', '網絡部\n', '網絡優化部\n', '計劃建設部\n', '新業務部\n',
      '採購及供應鏈部\n', '銷售部\n', '戰略部'],
    linkLabel: '詳情 >',
    tips: '此爲必填欄位',
    phone: '請輸入正確聯絡電話 ',
    email: '請輸入正確電郵格式',
    nameErr: '請輸入正確中文全名',
    go: '明白並繼續',
    applicable: '(如適用)',
    link: '/mylink/?currentGroup=0&currentContent=0&ishshhkhiking=1&isPark=0&sightname=鹿頸雞谷樹下 至 新娘潭路&lang=tc&/#/xingshan/route/12',
    'activity1': '4.14 遠足植樹日2019',
    'activity2': '遠足植樹日',
    'activity3': '遠足植樹日',
    'activity4': '全港動起來 向健康出發 為健康一齊行',
    'activity5': '活動日期：2019.4.14 （星期日）',
    'activity6': [
      '報名日',
      '報名截止',
      '活動日',
      '中午'
    ],
    'activity7': '活動詳情',
    'activity8': [
      '由中國移動香港及中國香港旅行遠足聯會主辦，秉承「為健康，一齊行」的信念，舉辦遠足植樹日（亦同為漁護署的「郊野公園遠足植樹日2019」）以推動全港市民參與，增進市民遠足步行的健康意識為長遠目標，並透過親手植樹加強對自然環境的了解和保護意識。',
      '',
      '遠足植樹日鼓勵市民在4月14日結伴參與，在節日親親大自然。當日亦會舉辦遠足植樹「萬步有禮」活動，鼓勵全港市民在全港任何一個角落一齊行，齊齊強身健體。',
      '  ',
      '舉行日期 : 2019年4月14日（星期日）',
      '活動時間：上午9時至中午12時',
      '報名日期：2019年3月26日 12:00（先到先得）',
      '',
      '活動秘書處：',
      '電話：2127 4720（星期一至五早上10時至晚上7時）',
      '電郵：wewalk.enquiry@gmail.com',
      '',
      '*由於植樹場地有限，每組參加者將有機會獲派一棵樹苗作植樹'
    ],
    'activity9': '活動路徑',
    'activity10': '遠足地點：鳳坑家樂徑',
    activityTree: '植樹地點：八仙嶺自然教育徑',
    'activity11': '遠足路線：鹿頸雞谷樹下 至 新娘潭路',
    'activity12': '行程：約1小時',
    'activity13': '長度：2公里',
    'activity14': '費用：全免',
    'activity15': '交通',
    'activity16': [
      '自行乘坐公共交通工具到達集合地點，或乘坐大會專車由九龍塘出發前往',
      '公共交通：從大埔墟站乘搭275R號巴士或20R號專線小巴至新娘潭站下車'
    ],
    'activity18': '立即報名',
    'activity19': '遠足植樹日行山活動2019',
    'activity20': '邀你報名',
    'activity21': '「遠足植樹日2019」萬步有禮活動',
    'activity22': [
      '大會除了舉辦「遠足植樹日2019」活動，亦鼓勵全港市民在全港任何一個角落一齊行，以健康的體魄迎接新一年，特意舉辦「萬步有禮」活動。',
      '全港市民只要在4月14日當日開啟並登入MyLink手機應用程式，透過WeWalk頁面內的計步功能並步行夠一萬步，即可參加活動。',
      '',
      '參加方法',
      '1. 登入MyLink',
      '2. 開啟「生活」內 WeWalk 頁面',
      '3. 當天行滿一萬步後，計步器將會發出提示',
      '',
      '獎品',
      '參加者只要成功在4月14 日行滿10,000步後，即可獲贈10,000 MyLink積分。（名額共1,000名，先到先得）',
      '電話：2127 4720（星期一至五早上10時至晚上7時）',
      '電郵：wewalk.enquiry@gmail.com',
      ''
    ],
    'activity23': '報名時間已結束',
    'activity24': '反應熱烈，是次活動名額已滿，多謝支持！',
    'activity25': '參與活動成功！',
    'activity26': '活動參與信息如下：',
    'activity27': [
      '參與組別：',
      '企業/機構名稱：',
      '組長：',
      '聯絡電話：',
      '額外參加者：',
      '主辦機構於活動前透過MyLink手機應用程式及電郵發出提示，屆時請留意活動最新資訊。'
    ],
    'activity28': '活動報名',
    'activity29': '請選擇報名組別',
    'activity30': '個人',
    'activity31': '企業/機構',
    'activity32': '名額已滿',
    'activity33': '活動報名',
    'activity34': '邀請碼',
    'activity35': '請輸入邀請碼',
    'activity36': '邀請碼無效，如有疑問請聯絡活動秘書處。',
    'activity37': '活動報名',
    'activity38': '企業/機構名稱',
    'activity39': '請輸入企業/機構名稱',
    'activity40': '所屬部門（按英文字母順序排列）',
    'activity41': '請選擇所屬部門',
    'activity42': '員工編號',
    'activity43': '請輸入員工編號',
    'activity44': '姓名',
    'activity45': '請輸入中文全名',
    'activity46': '年齡',
    'activity47': '請選擇年齡',
    'activity48': '18-69歲',
    'activity49': '6-17歲',
    'activity50': '5歲或以下',
    'activity51': '70歲以上',
    'activity52': '家長',
    'activity53': '監護人',
    'activity54': '家長/監護人姓名',
    'activity55': '請輸入家長/監護人姓名',
    'activity56': '本人聲明本人已年滿18歲（年齡以活動當日計算）。本人及同行參加者細閱並同意本活動之「參加者須知及條款細則」、「免責聲明」及「個人資料收集聲明」。主辦機構保留取消不接受上述條款之參加者的參加資格。',
    'activity57': '參加者年齡必須為6歲或以上',
    'activity58': '參加者必須自行評估身體狀況，確保體格適宜參加活動。如有疑問，請先諮詢醫生意見。',
    'activity59': '聯絡電話',
    'activity60': '請輸入聯絡電話',
    'activity61': '電郵',
    'activity62': '請輸入你的電郵',
    'activity63': '緊急聯絡人',
    'activity64': '請輸入緊急聯絡人姓名',
    'activity65': '緊急聯絡人聯絡電話',
    'activity66': '請輸入緊急聯絡人聯絡電話',
    'activity67': '緊急聯絡人資料同上',
    'activity68': '額外參加者（限X人）',
    'activity69': '添加額外參加者',
    'activity70': [
      '本人同意參加者參加「遠足植樹日2019」活動，亦證明本活動參加表格內提供的資料全部屬實。本人已知悉全部聲明内容，如有違反概由本人負責所有責任。',
      '',
      ''
    ],
    'activity71': '提交',
    'activity72': '資料一經提交不可修改，確定提交？',
    'activity73': '取消',
    'activity74': '確定',
    'activity75': '緊急聯絡人資料與參加者相同，請重新輸入',
    'activity76': '緊急聯絡人資料與參加者相同，請重新輸入',
    'activity77': '參加者資料重覆，請重新輸入',
    'activity78': '抱歉，當前剩餘報名名額不足，請刪除部分參加者再重試',
    'activity80': '另外查收文案'
  },
  weWalk: {
    start: '活動將於4月14日開始！',
    'weWalk1': '萬步有禮',
    'weWalk2': '活動時間：4月14日',
    'weWalk3': '活動介紹',
    'weWalk4': [
      '大會除了舉辦「遠足植樹日2019」活動，亦鼓勵全港市民在全港任何一個角落一齊行，以健康的體魄迎接新一年，特意舉辦「萬步有禮」活動。',
      '全港市民只要在4月14日當日開啟並登入MyLink手機應用程式，透過WeWalk頁面內的計步功能並步行夠一萬步，即可參加活動。'
    ],
    'weWalk5': '活動規則',
    'weWalk6': [
      '登入MyLink',
      '開啟「生活」內 WeWalk 頁面',
      '當天行滿一萬步後，計步器將會發出提示（名額共1,000名，先到先得）'
    ],
    'weWalk7': '如何打開MyLink計步器參與活動？',
    'weWalk8': [
      '參與活動前，請查看生活-WeWalk頁面步數資訊是否顯示正確（今日步數應大於0），如下圖：',
      ['如有問題，請點此', '查看原因']
    ],
    'weWalk9': ['查看', '活動條款及細則'],
    'weWalk10': '(請參閱電郵附件)',
    'weWalk11': '活動已結束',
    'weWalk12': '遠足植樹日',
    'weWalk13': '邀請參與萬步有禮活動',
    'weWalk14': '查閱活動紀錄',
    'weWalk15': '活動條款及細則',
    'weWalk16': '(請另參閱電郵附件)',
    'weWalk17': '活動結果',
    'weWalk18': '歡迎閣下參與活動',
    'weWalk19': '活動期間累積步數：',
    'weWalk20': '今日步數',
    'weWalk21': 'XXX步',
    'weWalk22': '查閱詳細紀錄',
    'weWalk23': ['距離獲得積分還差 ', ' 步，繼續加油哦！'],
    'weWalk24': '邀請好友參與',
    'weWalk25': ['查看', '活動詳情'],
    'weWalk26': ['在萬步有禮活動中已獲得', ' MyLink積分'],
    'weWalk27': '閣下已領取MyLink積分，感謝參與！',
    'weWalk28': '兌換禮品',
    'weWalk29': '萬步有禮活動',
    'weWalk30': '遠足植樹日最新消息：',
    'weWalk31': ['因天文台已經發出惡劣天氣警告，原訂今早舉行之活動將會取消',
      '「萬步有禮」活動則如常進行，敬希垂注。查詢可致電：2127 4720']
  },
  sign: {
    'route': '鳳坑家樂徑 (鹿頸雞谷樹下 至 新娘潭路)',
    'sign1': '現場簽到中',
    'sign2': '遠足植樹日2019',
    'sign3': [
      '植樹地點：八仙嶺自然教育徑',
      '遠足路線：鳳坑家樂徑 (鹿頸雞谷樹下 至 新娘潭路)'
    ],
    'sign4': '簽到',
    'sign5': '未能查詢閣下參與活動訊息，請與工作人員聯絡。',
    'sign6': '閣下已簽到！',
    'sign7': '2019年4月14日 xx:xx',
    'sign8': '姓名：',
    'sign9': '電話：',
    'sign10': '已選：',
    'sign11': '額外參與人員：',
    'sign12': '簽到結果',
    'sign13': '抱歉',
    'sign14': '請活動隊長掃描QR Code以簽到',
    'sign15': '簽到訊息確認',
    'sign16': '活動確認訊息如下:',
    'sign17': '額外人員',
    'sign18': '一經簽到後，人數不能改變！',
    'sign19': '取消',
    'sign20': '提交',
    'sign21': '登記結果',
    'sign22': '系統錯誤，請稍後再試！',
    'sign23': '簽到結果',
    'sign24': '閣下已簽到！'
  },
  activityRules: {
    content: ['本人聲明本人已年滿18歲（年齡以活動當日計算）。本人及同行參加者細閱並同意本活動之',
      '「參加者須知及條款細則」',
      '、',
      '「免責聲明」',
      '及',
      '「個人資料收集聲明」',
      '。主辦機構保留取消不接受上述條款之參加者的參加資格。" '],
    rule1: {
      title: '參加者須知及條款細則',
      content: [{
        title: '',
        list: ['「遠足植樹日2019」由中國移動香港有限公司 (「中國移動香港」) 及中國香港旅行遠足聯會 (「旅聯」) 聯合主辦。',
          '在下列的條款及細則內「活動」乃指2019年4月14日舉行的「遠足植樹日2019」行山活動；「所有參加者」包括所有參加者及額外參加者；「參加者」為參與是次活動並已年滿18歲（年齡以活動當日計算）的人士；「額外參加者」為參加者於報名時所申報同行的人士；「主辦機構」為中國移動香港及旅聯；「路線」是由主辦機構指定的行山路線；「MyLink」乃指由中國移動香港推出的MyLink手機應用程式。',
          '活動於2019年3月26日開始在MyLink接受報名，採用先到先得形式報名，額滿後即時停止接受登記，亦不設候補名單。主辦機構恕不接受MyLink以外的途徑報名。',
          '每名參加者可攜同一名額外參加者同行。報名者將是該組參加者的組長。',
          '參與活動確認一經遞交，即代表參加者及額外同行參加者確認及同意接受一切主辦機構不時所定之活動的規則、條款和安排。',
          '18歲以下的額外參加者必須於報名時同時完成由家長/監護人填寫之家長/監護人同意書。',
          '報名後一切資料不得更改。',
          '參加者必須於活動期間內使用其香港註冊的流動電話號碼註冊並登入MyLink參加本活動，每名參加者只限參加活動一次。如發現參加者以外掛程式或其他非正式途徑如空號或假帳戶或其他影響公平性的方式參加本活動，中國移動香港將取消該參加者的資格而不作另行通知。',
          '參加者必須於Google Play 或 App Store 下載MyLink。中國移動香港客戶（包括現有的儲值卡客戶、服務計劃客戶及用身份證登記的企業客戶）需以電話號碼及密碼或一次性密碼登入MyLink；MySim客戶及非中國移動客戶需以電話號碼及密碼登入MyLink。如以驗證碼登入，參加者必須提供支援短訊功能的香港手機號碼。',
          '如參加者需註冊成為MyLink用戶，參加者必須提供支援短訊功能的香港手機號碼以獲得一次性驗證碼進行身份驗證。如登記的手機號碼不支援短訊功能或不能使用、無效或在報名確認時已經更改，該參加者會被取消資格。',
        ]
      }, {
        title: '活動細節',
        list: ['活動會先進行植樹活動，起點為八仙嶺自然教育徑新娘潭路入口，步行至指定植樹地點。參加者必須於活動當日年滿18歲。額外參加者必須於活動當日年滿6歲。每名18歲以下的額外參加者必須事先獲家長或監護人簽署同意書方可參加。主辦機構保留在活動前後或進行期間，核實參加者及額外參加者的年齡及(如有需要)要求出示該等同意書證明的權利。',
          '樹苗及種植工具將在起點時派發。樹苗數量有限，派完即止。主辦機構派發樹苗時會盡量以每組參加者為單位，惟不保證每名參加者均可獲發樹苗。',
          '所有參加者須遵守主辦機構代表之植樹程序及規則植樹。主辦機構會提供基本工具，惟強烈建議參加者自行帶備勞工手套及其他保護工具。',
          '植樹部分完畢後，主辦機構將帶領所有參加者沿路下山回到起點，再前往鳳坑家樂徑進行行山活動。起點位於鹿頸雞谷樹下，終點位於新娘潭路。鳳坑家樂徑與植樹地點有一段距離，所有參加者可自行選擇是否參與。',
          '所有參加者成功報名參與活動後，將會收到主辦機構的確認電郵，要求所有參加者須在電郵所述的限期前申報病歷記錄，以便主辦機構知悉。',
          '主辦機構在得悉或懷疑情況下，保留拒絕接受報名或取消任何不適宜參加本活動人士的參加資格的權利，包括但不限於如參加者於活動當日年齡不足18歲、額外參加者於活動當日年齡不足6歲、提供錯誤資料、不能提交報名表、不依從正確報名程序報名、或身體狀況不適宜參加本活動（如懷有身孕、患慢性疾病如心臟病及高血壓人士）。',
          '所有參加者必須最遲於活動當天上午9時抵達新娘潭路獅子亭，逾時者會被取消參加資格。若所有參加者未能按照其指定參加組別及時間起步，或未能依循所報名的路線完成活動，主辦機構有權取消其參加資格。',
          '所有參加者不可攜帶或使用任何滾軸鞋、滑板、手推車或其他大型物件，亦不可攜同任何動物參與。',
          '所有參加者於活動前後及進行期間，必須遵照主辦機構、授權人員以及其他工作人員包括警察、民眾安全服務隊、醫療輔助隊、食物環境衞生署、康樂文化事務署及漁農自然護理署的所有合法指示。',
          '所有參加者請於活動期間保持禮貌的態度。',
          '步畢路線全程約2小時。沿途有上山路程，部分地區並無遮蓋，所有參加者需確保體力適宜才參與，如有疑問，應先向醫生查詢。植樹地點位於山區，參加者須步行前往。活動實際完結時間以主辦機構及授權人員所安排的押尾小隊決定為準。',
          '所有參加者需穿上合適的衣服及鞋襪，並自備充足飲品、食物、帽及雨具等。',
          '是次行山活動途徑泥路小徑，所有參加者須特別小心。請勿奔跑、爭先恐後、倚靠或攀爬沿途任何物件，以確保安全。',
          '所有參加者須清楚明白本活動內容及性質，並知道本活動需要消耗體力，同時確定健康情況適宜參與本活動。主辦機構建議所有參加者於活動期間自行留意個人的身體狀況是否良好及是否適合參與本活動。所有參加者於活動期間如有不適，請立即停止活動，並按需要向醫護人員求助。',
          ['主辦機構強烈建議所有參加者出發前先行搜集路線的資訊，並細閱漁農自然護理署網頁發佈的《郊野公園遠足安全指引》。',
            '《郊野公園遠足安全指引》：',
            'http://www.afcd.gov.hk/tc_chi/country/cou_vis/cou_vis_gac/cou_wha_whe_sat.html',
          ],
          ['主辦機構不保證路線全程均有流動網絡覆蓋及/或有緊急救助電話。主辦機構強烈建議所有參加者結伴同行，帶備手提電話後備電池、外置電源及/或對講機。主辦機構強烈建議參加者於出發前細閱漁農自然護理署網頁上的《郊野公園設施最新消息》，並不要前往《郊野公園曾發生致命及嚴重意外的高危地點》中所列出的所有地點。',
            '《郊野公園設施最新消息》：',
            'https://www.hiking.gov.hk/pathinfo/announcement.php',
            '《郊野公園曾發生致命及嚴重意外的高危地點》：',
            'https://www.hiking.gov.hk/fatal_and_accident_case/index_tc.htm',
          ],
          '參加者需自行承擔參與活動的一切責任。主辦機構及授權機構並不會對所有參加者於活動當天因任何事情或理由所引致的任何個人傷亡或財物損失承擔任何責任。',
          '主辦機構保留更改本條款及細則、其他活動細節、如路線等安排的權利。',
          '主辦機構若認為任何參加者或額外參加者沒有完全遵照或違反本條款及細則的規定、以不誠實手法參加或進行本活動及/或造假者，主辦機構有權取消該參加者或者額外參加者的資格或於行山活動中任何時間內終止該參加者或者額外參加者繼續參加，而不作任何通知，並對任何違反行為保留追究權利。如有任何爭議，主辦機構所作的決定為最終及不可推翻。',
        ]
      }, {
        title: '惡劣天氣',
        list: ['如天文台於活動當日早上六時或之後懸掛黑色暴雨、紅色暴雨、雷暴或三號颱風警告，或因天氣惡劣、任何天氣警告生效或其他原因而導致活動取消，主辦機構有權另擇日子舉行活動，或決定取消活動而不補辦。',
          '如活動進行期間天氣惡劣或懸掛上述任何天氣警告，又或主辦機構評估後判斷當天並不適合舉行活動，主辦機構有權將活動路徑改變或取消正在進行中的活動。主辦機構不會另擇日子補辦活動。',
          '主辦機構強烈要求所有參加者於活動舉行當天早上致電香港天文台查詢天氣情況。(電話：1878200)',
        ]
      }, {
        title: '其他事宜',
        list: ['主辦機構不會提供行李寄存。切勿攜帶貴重物品，如有損毀或遺失，主辦機構將不會負任何責任及作出任何賠償。',
          '所有參加者如活動過程中須向主辦機構查詢及要求協助，請沿途與就近工作人員聯絡。',
          '所有由主辦機構提供的活動包、禮品及任何其他物品(「禮品」)不可兌換現金，亦不能更換、退款、轉讓及轉售。本活動所有的禮品視乎供應情況而定，換領完即止。每名參加者或者額外參加者只可領取一份活動包，不可代他人領取。如任何因禮品所引起的爭議，主辦機構概不負責。',
          '主辦機構已就活動購買第三者保險。主辦機構建議所有參加者需自行購買個人意外保險。如參加者於活動開始前沒有於MyLink手機應用程式作電子簽到，則不獲活動第三者保險保障。',
          '主辦機構保留使用活動當天所拍得照片或錄像的權利，包括商業宣傳用途。',
          '主辦機構保留本活動的最終決定權。活動不設上訴機制。主辦機構擁有修改及解釋本條款及細則的權利，任何有關活動的臨時改動或取消，將以主辦機構公布為準。',
          '本條款及細則受香港法律管轄。所有參加者同意任何因本條款及細則所引起的任何訴訟或索賠受香港法院的專屬司法管轄權管轄。',
          '本條款及細則的中、英文版如有任何歧義，概以英文版為準。',
          '如有任何爭議，主辦機構將保留一切最終決定權。',
        ]
      }]
    },
    rule2: {
      title: '免責聲明',
      p: '謹此聲明本人參加本活動，並願意遵守由主辦機構所訂的條文及規則，以及同意以下所列各點：',
      list: ['本人是自願參加此活動和願意承擔自身的意外風險及責任，並無權向主辦機構對本人往返活動場地途中、活動中發生或引致之自身意外、死亡或任何形式的損失提出索償或追討責任。',
        '本人聲明本人身體情況良好及有能力參加此活動，及沒有執業醫生曾提出相反意見。',
        '本人願意接受主辦機構要求及提供的藥物檢查及治療。',
        '本人於活動當天（2019年4月14日）已經符合參加組別之最低年齡規定（如參加者未年滿18歲，須由其家長或監護人簽署同意聲明）。',
        '本人明白及同意本人的個人資料將轉交予主辦機構用作活動安排之用途。',
        '本人證實已事先獲得同行參加者及/或緊急聯繫人的同意，可使用其個人資料於本活動的報名表格作報名及/或緊急聯繫用途。',
        '本人願意授權予及同意主辦機構及傳媒在不需要審查情況及不需要本人另外同意下而可使用本人的個人資料、肖像、姓名及聲線作為籌辦及推廣活動之用，包括本人肖像及姓名有可能被使用於主辦機構有關本活動之網頁、短片及刊物。',
        '本人提交確認即表示同意及確認所有列明之「參加者須知及條款細則」、「免責聲明」及「個人資料收集聲明」，以及所有不時於活動指定宣傳渠道更新的任何更改。',
      ]
    },
    rule3: {
      title: '個人資料收集聲明',
      p: '',
      list1: ['主辦機構將會在參加者報名參與「遠足植樹日2019」行山活動並獲即時確認出席資格時，收集參加者的個人資料，包括姓名、手提電話號碼、電郵地址、病歷記錄、食物敏感資料等。主辦機構保障參加者所提供之一切資料。當參加者提交確認時，有關個人資料將會被收集、儲存及使用以作核實。',
        '本聲明乃遵照《個人資料(私穩)條例》(第486章)的要求而發出，通知您作為參加者收集資料的目的、您同意主辦機構如何使用這些資料及您的權利。本聲明會不時更改，故請定期查閱。參加者每次登記及/或使用我們的服務時，即表示同意接受當時生效之個人資料收集聲明。',
        '參加者可能會被要求向主辦機構提供個人識別資料。為讓參加者可以參加「遠足植樹日2019」行山活動，該些資料是必要的。倘若參加者未能提供所需資料，參加者將不能獲得活動參加資格。',
      ],
      list2: ['識別和核實參加活動的參加者的身份及/或資格；',
        '就有關或因參加活動的事項與參加者或其緊急聯繫人溝通；',
        '匯編參加者的整體統計資料，分析、評估及改進主辦機構所提供的活動',
      ],
      list3: ['參加者之個人資料將被保密。然而由於系統管理、運作及保養需要，主辦機構會將有關資料轉移或披露予對主辦機構有保密責任並提供與主辦機構運作有關行政、電訊、電腦系統服務、數據處理或其他服務的承辦商。',
        '參加者有權根據《個人資料（私隱）條例》(第486章)的規定，要求查閱或更正參加者之個人資料。如有任何查閱或更正資料的要求，請向中國移動香港的公司資料保障主任提出，其辦事處位於香港新界葵涌葵昌路51號九龍貿易中心1座20樓。中國移動香港的私隱政策聲明可於其網頁www.hk.chinamobile.com獲取。'
      ],
      list: ['資料之目的及用途', '主辦機構所收集之資料將用作以下用途：', '資料之轉移',]
    }
  }
}


// WEBPACK FOOTER //
// ./src/locale/activity/zh-hk.js